import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div
      className="min-h-screen bg-white flex flex-col justify-center items-center text-center px-6 py-12"
    >
      <img
        src="/images/404.svg"
        alt={t('notFound.title')}
        className="w-48 my-8"
        onError={(e) => {
          e.target.src = "/images/construction.svg"; // Fallback à l'image de construction si 404.svg n'existe pas
        }}
      />
      <h1 className="text-3xl font-bold text-socabeg-blue mb-4">
        404 - {t('notFound.title')}
      </h1>
      <p className="text-lg text-gray-700 max-w-xl mb-6">
        {t('notFound.message')}
      </p>
      <Link
        to="/"
        className="bg-socabeg-blue text-white px-6 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-colors duration-300 mb-8"
      >
        {t('notFound.backHome')}
      </Link>
      <p className="text-gray-600 text-base mb-6">
        {t('notFound.contact')}<br />
        <strong>{t('notFound.email')}</strong>{" "}
        <a
          href="mailto:infos@socabeg.com"
          className="text-socabeg-blue underline"
        >
          infos@socabeg.com
        </a>
        <br />
        <strong>{t('notFound.phone')}</strong>{" "}
        <a
          href="tel:+22133338893535"
          className="text-socabeg-blue underline"
        >
          +221 33 889 35 35
        </a>
      </p>
    </div>
  );
}
